import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../config";

// Define a service using a base URL and expected endpoints
export const subscriptionApi = createApi({
  reducerPath: "subscriptionApi",
  tagTypes: ["Subscription","Payment"],
  baseQuery: fetchBaseQuery({
    baseUrl: config.base_url,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("token");
      headers.set("Access-Control-Allow-Origin", "*");
      headers.set("Authorization", "Bearer " + token);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getSubscription: builder.query({
      query: (type) => "/subscription?type=" + type,
    }),
    addIntrested: builder.mutation({
      query: (planId) => "/interested?plan_id=" + planId,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSubscriptionQuery, useAddIntrestedMutation } =
  subscriptionApi;
